import type { QuickAnchorFixItem } from './QuickAnchorFix';
import { getMiniPdpProductData } from '../../components/MiniPdpModal/mockGraphql';
import { buildMiniPdpProduct } from '../../components/MiniPdpModal/buildMiniPdpProduct';
import type { QuickAnchorSchedulingContent } from './QuickAnchorSchedulingModal';

// OMNI-4521 builds the layout before the recovery page GraphQL contract lands.
// Keep all temporary product and delivery data here for the integration ticket.
// Reuse distinct product hero images from the existing Anchor Fix, pagination,
// results, and review fixtures (rather than alternate views of the same item).
const mockImageBaseUrl =
  'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/';

const mockProductImages = [
  '/v1630400080/gadrud7bxfuzufmtqkgy.jpg',
  '/v1743720891/sliksbb3jucel4ehheau.jpg',
  '/v1736798503/pvfbfzfdlzeq8izlonhu.jpg',
  '/v1743614178/ycjo2xzkdziofqhkm73l.jpg',
  '/v1742590239/g6g7rbfn6s9vdwztdljf.jpg',
  '/v1744132712/e5momuqxcanvcoehfkog.jpg',
  '/v1741402088/kycywspexcupbtm8hnay.jpg',
  '/v1709433490/gk3duiqin0fw3hsd2sjr.jpg',
  '/v1741639596/hmkc558s5nerjzpg14ko.jpg',
  '/v1719389728/dzuqw985onbkvrznrh7t.jpg',
];

export const mockItems: QuickAnchorFixItem[] = mockProductImages.map(
  (mediaPath, index) => {
    const item: QuickAnchorFixItem = {
      sku: `quick-anchor-mock-${index + 1}`,
      brand: 'Brand',
      name: `Product ${index + 1}`,
      price: '$100.00',
      size: 'M',
      inseam: '30',
      colorName: 'Navy',
      saved: index < 2,
      heroMedia: {
        alt: `Anchor recommendation ${index + 1}`,
        baseUrl: mockImageBaseUrl,
        mediaPath,
        sizes: { sm: 224 },
      },
    };

    // Keep the deployed mock page usable without relying on development MSW.
    // Share the same details as the query fixtures until real SKUs are supplied.
    return {
      ...item,
      ...buildMiniPdpProduct(
        getMiniPdpProductData(item).shopProductBySkuId,
        item.sku,
      ),
    };
  },
);

export const mockEstimatedDeliveryDate = 'Wednesday, December 30';
export const mockContinuePath = '/client/referrals';

// Replace with backend-owned scheduling dates and autoship copy on integration.
export const mockSchedulingContent: QuickAnchorSchedulingContent = {
  headline: `Schedule your next Fix for\n${mockEstimatedDeliveryDate}?`,
  selectedItemLabel: 'You picked this item',
  autoshipCopy:
    'Your Fix schedule will be adjusted to make room for this order. Your next recurring Fix will arrive on or around January 27.',
  confirmLabel: 'Schedule your Fix',
};
